import { StaticNode } from '..';
import { NodeData, StaticTreeDataSourceOptions } from '../dataSourceTypes';
import { DraggableTreeDataSource } from './base/draggableDataSource';

export class StaticTreeDataSource extends DraggableTreeDataSource<StaticTreeDataSourceOptions> {
  private staticNodes: Array<StaticNode>;

  constructor(options: StaticTreeDataSourceOptions) {
    super(options);
    this.buildStaticNodes();
  }

  /**
   * Method used to retrieve static nodes.
   */
  public requestStaticNodes(rootNodeId: string): Promise<Array<StaticNode> | null> {
    return this.options.requestStaticNodes(rootNodeId);
  }

  /**
   * Methods that sets static nodes on the dataSource.
   * Setting them via the setter will prevent the requestStaticNodes method to be triggered.
   */
  public setStaticNodes(staticNodes: Array<StaticNode>): void {
    this.staticNodes = staticNodes;
    this.buildStaticNodes();
  }

  public async toggleNodeOpen(node: NodeData, isOpen = !node.isOpen): Promise<void> {
    node.isOpen = isOpen;
    this.nodes.set(node.nodeId, node);
    this.emitNodeChanges();
  }

  private async buildStaticNodes(): Promise<void> {
    this.nodes = new Map();
    const staticNodes: Array<StaticNode> =
      this.staticNodes || (await this.retrieveStaticNodes(this.options.rootNodeIds));

    this.setNodeFromStaticNode(staticNodes);
    this.emitNodeChanges();
  }

  private retrieveStaticNodes(rootNodeIds: Array<string>): Promise<Array<StaticNode | null>> {
    return Promise.all(rootNodeIds.map(rootNodeId => this.requestStaticNodes(rootNodeId))).then(responses =>
      responses.flat()
    );
  }

  private setNodeFromStaticNode(staticNodes: Array<StaticNode>, parentNodeId?: string): void {
    for (const node of staticNodes) {
      this.nodes.set(node.nodeId, {
        ...node,
        parentNodeId,
        childNodeIds: node.childNodes?.map(({ nodeId }) => nodeId),
      });

      if (node.childNodes?.length) {
        this.setNodeFromStaticNode(node.childNodes, node.nodeId);
      }
    }
  }
   public loadPagedNodes(targetNode: NodeData, page: number): void {};
}
